export default __webpack_public_path__ + "static/media/smooth.d7172c7d.mp3";